<template>
  <div class="wtc-choose-calendar-wrap">
    <calendar ref="calendar" :calendarType="calendarType" :currentMonth="currentMonth" :earliestMonth="earliestMonth"
              :model="model" :maxChoose="maxChoose" :dateList="dateList" :KDApi="KDApi"></calendar>
  </div>
</template>

<script>
import calendar from "./calendar.vue";

export default {
  name: "attendanceCalendar",
  components: {
    calendar,
  },
  props: ['calendarType','model', 'currentMonth', 'earliestMonth', 'KDApi', 'maxChoose', "dateList"],

  data() {
    return {
      showDetail: false,

      attRecord: {
        date: "2022-05-01",
        existAtt: true, // 当天是否需要出勤
        abnormal: false, // 考勤是否异常
        workHours: "7小时30分钟", //工时
        shiftPeriod: ["09:00-12:00"],
        cardRecord: [],
        details: []
      },
    };
  },

  methods: {
    updateChooseDate(dateList) {
      this.$refs.calendar.updateChooseDate(dateList);
    },
  },

};
</script>

<style>
.wtc-choose-calendar-wrap {
  width: 100%;
  font-size: 14px;
  color: #212121;
  overflow: hidden;
  background-color: #fff;
}

.wtc-choose-calendar-wrap .wtc-choose-calendar-fold-btn {
  text-align: center;
  padding: 6px 0;
}

.wtc-choose-calendar-wrap .wtc-choose-calendar-fold-btn>span {
  font-size: 30px;
}

.wtc-calendar-slide-enter-active,
.wtc-calendar-slide-leave-active {
  transition: max-height .5s;
}

.wtc-calendar-slide-enter,
.wtc-calendar-slide-leave-to {
  max-height: 0;
}

.wtc-calendar-slide-enter-to,
.wtc-calendar-slide-leave {
  max-height: 40rem;
}
</style>